import * as PropTypes from "prop-types";
import {connect} from "react-redux";
import {ActionsRow, commons, FixedDropDownButton, Icon, Loader, modal, utils} from "@mc/mc-legacy";
import {Button, ButtonToolbar, Card, CardBody, CardHeader, Col, DropdownItem, Row} from "reactstrap";
import UzivatelForm from "../forms/UzivatelForm";
import SubjektApi from "../api/gen/cgo/SubjektApi";
import * as subjektActions from "../actions/subjektActions";
import {withRouter} from "react-router";
import PripojitZamestnanceForm from "../forms/PripojitZamestnanceForm";
import NastaveniObjednavkyUzivatelForm from "../forms/NastaveniObjednavkyUzivatelForm";
import {ADMIN_BASE_PATH, UZIVATELE_PATH} from "../const/routes";
import * as opravneniActions from "../actions/opravneniActions";
import * as EnumRole from "../api/gen/cgo/EnumRole";
import * as EnumRoleInfo from "../api/EnumRoleInfo";
import {toastr} from "react-redux-toastr";
import * as React from "react";
import {Component} from "react";
import {withTranslation, WithTranslation} from "react-i18next";

const {sinkEvent} = commons;

/**
 * Panel zobrazující seznam zaměstnanců společnosti.
 */
class ZamestnanciPanel extends Component<WithTranslation> {

    static propTypes = {
        spolecnostId: PropTypes.number.isRequired, // ID společnosti, noví uživatelé budou přiřazeni této společnosti,
        zamestnanciList: PropTypes.array.isRequired, // seznam zaměstnanců společnosti
    };

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        const {spolecnostId} = this.props;
        this.props.dispatch(opravneniActions.fetchLoggedInUserIfNeeded());
        this.props.dispatch(subjektActions.fetchSpolecnostRightsIfNeeded(spolecnostId));
    };

    handleShowZamestnanec = (zamestnanec) => {
        this.props.history.push(`/${ADMIN_BASE_PATH}/${UZIVATELE_PATH}/${zamestnanec.id}`);
    };

    handleCreateZamestnanec = () => {
        const {spolecnostId, loggedInUser, t} = this.props;
        let vychoziRole = null;
        if (loggedInUser.data.editaceUzivatelRoleList.length > 0) {
            vychoziRole = loggedInUser.data.editaceUzivatelRoleList[0];
        }
        this.props.dispatch(modal.ModalActions.show(
            UzivatelForm,
            {
                onSubmit: (data) => {
                    return SubjektApi.createUzivatel(data, spolecnostId);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(subjektActions.invalidateUzivatele());
                    dispatch(subjektActions.invalidateUzivateleSpolecnosti());
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: {
                    role: vychoziRole,
                },
            },
            t('employee.new'),
            {size: "md"}
        ));
    };

    handleEditZamestnanec = (zamestnanec) => {
        const {loggedInUser, t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            UzivatelForm,
            {
                onSubmit: (data) => {
                    return subjektActions.updateUzivatel(data);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(subjektActions.invalidateUzivatele());
                    dispatch(subjektActions.invalidateUzivatelDetail(data.id));
                    dispatch(subjektActions.invalidateUzivateleSpolecnosti());
                    if (loggedInUser.data.id === zamestnanec.id) {
                        dispatch(opravneniActions.invalidateLoggedInUser());
                    }
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: zamestnanec
            },
            t('employee.edit'),
            {size: "md"}
        ));
    };

    handleEditPredvolby = (zamestnanec) => {
        const {spolecnostId, t} = this.props;
        const {loggedInUser, zpusobDopravaVychozi, zpusobPlatbaVychozi, notifikaceEmail, notifikaceSms} = zamestnanec;
        this.props.dispatch(modal.ModalActions.show(
            NastaveniObjednavkyUzivatelForm,
            {
                onSubmit: (data) => {
                    return SubjektApi.updateUzivatelPredvolby(data, zamestnanec.id);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(subjektActions.invalidateUzivatelDetail(data.id));
                    if (loggedInUser.data.id === data.id) {
                        dispatch(opravneniActions.invalidateLoggedInUser());
                    }
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: {zpusobDopravaVychozi, zpusobPlatbaVychozi, notifikaceEmail, notifikaceSms},
                spolecnostId
            },
            t('employee.preferences_edit'),
            {size: "md"}
        ));
    };

    handleOdpojitZamestnance = (zamestnanec) => {
        const {spolecnostId, t} = this.props;
        this.props.dispatch(
            modal.ModalActions.showConfirm(
                t('employee.disconnection'),
                t('employee.disconnection_prompt', {employee: zamestnanec.zobrazJmeno}),
                () => {
                    SubjektApi.unlinkSpolecnostUzivatel(spolecnostId, zamestnanec.id).then(() => {
                        this.props.dispatch(subjektActions.invalidateUzivateleSpolecnosti());
                    });
                },
                null,
                t('disconnect')
            )
        );
    };

    handlePripojZamestnance = () => {
        const {spolecnostId, loggedInUser, t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            PripojitZamestnanceForm,
            {
                mimoSpolecnostId: spolecnostId,
                onSubmit: (data) => {
                    if (loggedInUser.data.role === EnumRole.ADMIN) {
                        return SubjektApi.linkSpolecnostUzivatel(spolecnostId, data.uzivatel.id);
                    } else {
                        return SubjektApi.findUzivatelByLogin(data.uzivatel).then((uzivatel) => {
                            if (uzivatel) {
                                return SubjektApi.linkSpolecnostUzivatel(spolecnostId, uzivatel.id);
                            } else {
                                toastr.error(t('employee.not_found'));
                                return true;
                            }
                        });
                    }
                },
                onSubmitSuccess: (result, dispatch) => {
                    if (!result) {
                        dispatch(modal.ModalActions.hide());
                        dispatch(subjektActions.invalidateUzivateleSpolecnosti());
                    }
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
            },
            t('employee.connection'),
            {size: "sm"}
        ));
    };

    renderActions = () => {
        const {spolecnostRightsDetail, loggedInUser, t} = this.props;
        const spolecnostRights = spolecnostRightsDetail.data;
        const canCreateUzivatel = (spolecnostRights.uzivatelEdit || loggedInUser.data.rgSpolecnostSpravaUziv)
            && (loggedInUser.data.role === EnumRole.ADMIN || loggedInUser.data.role === EnumRole.SPRAVSPOL)
            && !loggedInUser.data.extSystemRezim;

        return <ButtonToolbar>
            {spolecnostRights.uzivatelLinkSpolecnost && <Button onClick={this.handlePripojZamestnance}>{t('connect')}</Button>}
            {canCreateUzivatel && <Button onClick={this.handleCreateZamestnanec}>{t('new_m')}</Button>}
        </ButtonToolbar>
    };

    renderContextMenu = (zamestnanec) => {
        const {spolecnostRightsDetail, t} = this.props;
        const spolecnostRights = spolecnostRightsDetail.data;
        return <FixedDropDownButton color="action action-hover" noCaret title={<Icon icon="ellipsis-v"/>}>
            <DropdownItem key="0" onClick={sinkEvent(this.handleShowZamestnanec.bind(this, zamestnanec))}>{t('show_detail')}</DropdownItem>
            <DropdownItem key="1" onClick={sinkEvent(this.handleEditZamestnanec.bind(this, zamestnanec))}>{t('edit_details')}</DropdownItem>
            <DropdownItem key="2" onClick={sinkEvent(this.handleEditPredvolby.bind(this, zamestnanec))}>{t('edit_preferences')}</DropdownItem>
            {spolecnostRights.uzivatelLinkSpolecnost && <DropdownItem key="3" onClick={sinkEvent(this.handleOdpojitZamestnance.bind(this, zamestnanec))}>{t('employee.disconnect_from_company')}</DropdownItem>}
        </FixedDropDownButton>
    };

    render() {
        const {loggedInUser, zamestnanciList, spolecnostRightsDetail, t} = this.props;

        if (!loggedInUser.fetched || !spolecnostRightsDetail.fetched) {
            return <Loader/>;
        }

        return <Card className="zamestnanci-panel">
            <CardHeader>
                <ActionsRow actions={this.renderActions()}>
                    <h2>{t('employee.many')}</h2>
                </ActionsRow>
            </CardHeader>
            <div className="items-list">
                {zamestnanciList.length > 0 ? zamestnanciList.map(zamestnanec =>
                    <CardBody key={zamestnanec.id}>
                        <ActionsRow actions={this.renderContextMenu(zamestnanec)} onClick={this.handleShowZamestnanec.bind(this, zamestnanec)}>
                            <Row>
                                <Col xs={8} sm={4}>
                                    {zamestnanec.zobrazJmeno}
                                </Col>
                                <Col xs={4}>
                                    {EnumRoleInfo.getCaption(zamestnanec.role, t)}
                                </Col>
                            </Row>
                        </ActionsRow>
                    </CardBody>
                ) : <CardBody><i>{t('employee.none')}</i></CardBody>}
            </div>
        </Card>
    }
}

function mapStateToProps(state) {
    return {
        loggedInUser: utils.storeFromArea(state, opravneniActions.LOGGED_IN_USER_AREA),
        spolecnostRightsDetail: utils.storeFromArea(state, subjektActions.SPOLECNOST_RIGHTS_AREA),
    }
}

export default withRouter(connect(mapStateToProps)(withTranslation()(ZamestnanciPanel)));
